import React, { ReactNode, RefObject } from 'react';
import { Link } from 'react-router-dom';
import { Field, Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { I18n, Translate } from 'react-redux-i18n';
import TextInput from '../../common/inputs/TextInput';
import CheckboxInput from '../../common/inputs/CheckboxInput';
import Button from '../../common/Button';
import logo from '../../../img/createAccount/email_recuperation.svg';
import { CGU } from '../../../routes';
import Captcha from '../../common/Captcha';

type Props = {
  divRef: RefObject<HTMLDivElement>;
  endForm: (values) => void;
  activation?: boolean,
  initialMail?: string,
  fromEnrolement?: boolean,
  isLoading: boolean,
};

type Form = {
  email: string;
  eulaAccepted: boolean;
  captchaResponse: string;
};

class ActivationMail extends React.PureComponent<Props> {
  static defaultProps = {
    activation: false,
    fromEnrolement: false,
  };

  captcha = React.createRef<Captcha>();

  handleSubmit = async (formValues: Form): Promise<{ [FORM_ERROR]: string }> => {
    try {
      this.props.endForm(formValues);
      if (this.captcha) {
        this.captcha.current.resetCaptcha();
      }
      return null;
    } catch (err) {
      return { [FORM_ERROR]: 'fal fa-exclamation-circle' };
    }
  };

  render(): ReactNode {
    const { initialMail, activation, fromEnrolement } = this.props;
    return (
      <div ref={this.props.divRef} className="account-activation-form-container">
        <div className="account-activation-col">
          <h3><Translate value="ACTIVATION.RECUPERATION_MAIL" /></h3>
        </div>
        <div className="account-activation-col">
          <Translate className="information-text" value="ACTIVATION.MAIL_GOAL" />
          <Form
            onSubmit={this.handleSubmit}
            initialValues={{
              email: initialMail,
              eulaAccepted: false,
              captchaResponse: undefined,
            }}
            validate={(values: Form) => {
              if (values.eulaAccepted && values.captchaResponse === undefined && this.captcha) {
                this.captcha.current.forceCaptcha();
              }
              return {};
            }}
            render={(
              {
                handleSubmit,
                submitError,
                submitting,
                values,
              },
            ) => (
              <form className="connection-information-form" onSubmit={handleSubmit}>
                {submitError && <div className="error">{submitError}</div>}
                <Field
                  name="email"
                  component={TextInput}
                  placeholder={I18n.t('ACTIVATION.MAIL')}
                  type="text"
                  fieldType="email"
                  readOnly={fromEnrolement}
                  required
                />
                <Field
                  name="eulaAccepted"
                  component={CheckboxInput}
                  placeholder={(
                    <div>
                      <Translate value="ACTIVATION.CONDITIONS" />
                      <Link target="_blank" to={CGU}><Translate value="ACTIVATION.CONDITIONS_LINK" /></Link>
                    </div>
                  )}
                  fieldType="checkbox"
                  type="checkbox"
                  required
                />
                <Field name="captchaResponse">
                  {(props) => (
                    <Captcha onValidate={props.input.onChange} ref={this.captcha} />
                  )}
                </Field>
                <div className="button-container">
                  <Button
                    isLoading={this.props.isLoading}
                    type="primary"
                    buttonType="submit"
                    i18nKey={`${activation ? 'ACTIVATION.ACTIVATE' : 'CREATION.CREATE'}`}
                    disabled={submitting
                    || values.email === null
                    || values.email === undefined
                    || values.eulaAccepted === false}
                  />
                </div>
              </form>
            )}
          />
        </div>
        <div className="account-activation-col">
          <div>
            <img className="logo" src={logo} alt="logo" />
          </div>
          <div className="multiple-span">
            <Translate value="ACTIVATION.UNIQUE_ACCESS_MAIL" />
            <Translate value="ACTIVATION.WONT_BE_USED_MAIL" />
          </div>
        </div>
      </div>
    );
  }
}

export default ActivationMail;
